/* TRUSS Toolkit theme script.
   Two small interactive pieces: the supplier example switch and the step selector.
   Without this script both still show all their content, stacked. */
(function () {
  function initExample(root) {
    var seg = root.querySelector('[data-seg]');
    if (!seg) return;
    var buttons = seg.querySelectorAll('[data-view]');
    var panels = root.querySelectorAll('[data-panel]');
    function show(view) {
      seg.setAttribute('data-view', view);
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-view') === view ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.hidden = p.getAttribute('data-panel') !== view;
      });
    }
    buttons.forEach(function (b) {
      b.addEventListener('click', function () { show(b.getAttribute('data-view')); });
    });
  }

  function initSteps(root) {
    var chips = root.querySelectorAll('[data-step-chip]');
    var steps = root.querySelectorAll('[data-step]');
    if (!chips.length) return;
    function show(index, moveFocus) {
      chips.forEach(function (c) {
        c.setAttribute('aria-pressed', c.getAttribute('data-step-chip') === index ? 'true' : 'false');
      });
      steps.forEach(function (s) {
        s.hidden = s.getAttribute('data-step') !== index;
      });
      if (moveFocus) {
        var chip = root.querySelector('[data-step-chip="' + index + '"]');
        if (chip) chip.focus();
      }
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () { show(c.getAttribute('data-step-chip'), false); });
    });
    root.querySelectorAll('[data-go-step]').forEach(function (b) {
      b.addEventListener('click', function () { show(b.getAttribute('data-go-step'), true); });
    });
    var first = chips[0].getAttribute('data-step-chip');
    show(first, false);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-example]').forEach(initExample);
    (scope || document).querySelectorAll('[data-steps]').forEach(initSteps);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Re-run when a section is added or changed in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
